import { Link } from 'react-router-dom';

import { appConfig } from '../../../../config/app-config';

interface CartHeaderProps {
  storeKey?: string;
  eventKey?: string;
  linkText?: string;
}

const CartHeader = ({ storeKey, eventKey, linkText = 'Add more passes' }: CartHeaderProps) => (
  <div className="flex justify-between items-baseline mb-[32px] bg-transparent rounded-none pb-3 shadow-none border-b-0">
    <h1 className="font-aleo text-[26px] font-semibold text-[#030407] leading-[32px] mb-2">
      Basket
    </h1>
    <Link
      to={`/${storeKey || appConfig.defaults.storeKey}/${eventKey}`}
      className="font-bold text-sm leading-5 tracking-[0px] text-[#101828] no-underline hover:text-gray-700"
    >
      {linkText}
    </Link>
  </div>
);

export default CartHeader;
